import React from 'react';

import 'bootstrap/dist/css/bootstrap.css';
import './image-with-caption.styl'

class ImageWithCaption extends React.Component {

  render(){
    return (
      <div className="image-with-caption">
        <img src={ this.props.src } alt={ this.props.src } />
        <span>{ this.props.caption }</span>
      </div>
    );
  }
}

export default ImageWithCaption;



// WEBPACK FOOTER //
// ./src/components/image-with-caption/image-with-caption.js